/**
 * Deep L: a reservoir of diamonds and boulders over three slime floors. Dig each channel under a
 * floor and everything above seeps down into it, layer by layer, until it reaches the tunnel
 * you dig under the last floor (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepL: CaveDef = {
  id: 'L',
  name: 'UNDERTOW',
  hint: 'Dig the channels one by one; the diamonds sink to you.',
  intermission: false,
  colors: [6, 14, 3],
  diamondValue: 25,
  extraValue: 45,
  fill: { base: '.', items: [['r', 12], ['d', 5]] },
  levels: [
    { seed: 6201, diamonds: 16, time: 150 },
    { seed: 6202, diamonds: 18, time: 140 },
    { seed: 6203, diamonds: 20, time: 130 },
    { seed: 6204, diamonds: 22, time: 120 },
    { seed: 6205, diamonds: 24, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.P??????????????????????????????????..W',
    'W...?????????????????????????????????..W',
    'W......................................W',
    'W..wrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrw..W',
    'W..wdrddrdrddrdrddrdrddrdrddrdrddrdrw..W',
    'W..wssssssssssssssssssssssssssssssssw..W',
    'W......................................W',
    'W..wssssssssssssssssssssssssssssssssw..W',
    'W......................................W',
    'W..wssssssssssssssssssssssssssssssssw..W',
    'W......................................W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
